import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { AnyTagFilterProps } from '@/services/types/globals.type';
import useEmblaCarousel from 'embla-carousel-react';
import FullWidthSection from './full-width-section';

function TagFilter({ list, selected, onFilterChange }: AnyTagFilterProps) {
  const [emblaRef] = useEmblaCarousel({
    dragFree: true,
    containScroll: 'keepSnaps',
  });

  return (
    <FullWidthSection>
      <div className="flex flex-col items-start">
        {/* 필터 버튼들 */}
        <div ref={emblaRef} className="hide-scrollbar w-full overflow-x-auto">
          <div className="flex gap-2 first:ml-6 last:mr-6">
            {list.map((item) => {
              const isActive = selected.some((f) => f.value === item.value);
              return (
                <Button
                  key={item.value}
                  onClick={() => onFilterChange(item)}
                  className={cn(
                    'typo-16 desktop:typo-20 desktop:px-[32px] desktop:h-14 flex-shrink-0 cursor-pointer rounded-md px-5 py-3',
                    isActive
                      ? 'text-level-2 bg-main-yellow desktop:font-extrabold font-bold'
                      : 'text-font-grayblue bg-bg-grayblue font-semibold hover:bg-gray-200',
                  )}
                >
                  <span>{item.label}</span>
                </Button>
              );
            })}
          </div>
        </div>
      </div>
    </FullWidthSection>
  );
}

export default TagFilter;
